import { Box, InputAdornment, Typography } from '@mui/material';
import { InputKit } from '../InputKit';
import { DynamicInputProps, InputType } from './types';
import { memo, useMemo } from 'react';
import { SelectKit } from '../SelectKit';
import { TextareaKit } from '../TextareaKit';
import { PhoneNrInput } from '../PhoneNrInput';
import { DatePickerKit } from '../DatePickerKit';
import countries from '../../../Utilis/Country';
import { states } from '../../../Utilis/States';

export const DynamicInput = memo(
  ({
    name,
    title,
    type,
    placeholder,
    values,
    disabled = true,
  }: DynamicInputProps) => {
    const shared = {
      name,
      placeholder,
      disabled,
    };

    const getInput = () => {
      switch (type) {
        case InputType.INPUT:
        case InputType.NUMBER:
        case InputType.VALUE:
          return (
            <InputKit
              type={type === InputType.INPUT ? 'text' : 'number'}
              InputProps={
                type === InputType.VALUE
                  ? {
                      startAdornment: (
                        <InputAdornment position='start'>$</InputAdornment>
                      ),
                    }
                  : undefined
              }
              {...shared}
            />
          );
        case InputType.SSN:
          return (
            <InputKit
              mask='999-99-9999'
              {...shared}
              placeholder='XXX-XX-XXXX'
            />
          );
        case InputType.EIN:
          return (
            <InputKit mask='99-9999999' {...shared} placeholder='XX-XXXXXXX' />
          );
        case InputType.BOOLEAN:
          return (
            <SelectKit
              options={[
                { label: 'Yes', value: true },
                { label: 'No', value: false },
              ]}
              {...shared}
            />
          );
        case InputType.TEXTAREA:
          return <TextareaKit {...shared} />;
        case InputType.EMAIL:
          return <InputKit type='email' {...shared} />;
        case InputType.PHONE_NUMBER:
          return <PhoneNrInput {...shared} />;
        case InputType.DATE:
          return <DatePickerKit {...shared} />;

        case InputType.COUNTRIES:
          return (
            <SelectKit
              options={countries.map(country => ({
                label: country.name,
                value: country.code,
                icon: country.flag,
              }))}
              {...shared}
            />
          );
        case InputType.STATES:
          return <SelectKit options={states} {...shared} />;
        case InputType.SELECT:
        case InputType.MULTISELECT:
          return (
            <SelectKit
              options={values}
              multiple={type === InputType.MULTISELECT}
              {...shared}
            />
          );
        default:
          return <></>;
      }
    };

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          flex: 1,
        }}
      >
        {!!title && (
          <Typography sx={{ fontSize: '14px', color: '#344054' }}>
            {title}
          </Typography>
        )}
        {getInput()}
      </Box>
    );
  }
);

export default DynamicInput;
